import { useForm } from "react-hook-form";
import "./acas-info.css";
import Swal from "sweetalert2";
import axios from "axios";
import { Modal, Spinner } from "react-bootstrap";
import { useState } from 'react';


function AcasInfo({ awbInfo, existAcas, updateAcasInfo }) {
  const { handleSubmit, register, watch } = useForm({
    defaultValues: {
      acasvalue: "",
      onHoldValue: "",
    },
  });

  const acasValue = watch("acasvalue");
  const [loading, setLoading] = useState(false);


  const handleAcceptAca = async (data) => {
    setLoading(true);
    if (
      data.acasvalue === "" ||
      (data.acasvalue === "false" && data.onHoldValue === "")
    ) {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Faltan campos por llenar",
        icon: "error",
      });
      return;
    }

    const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/acas/save_acas`;
    const body = {
      acasvalue: data.acasvalue,
      onHoldValue: data.onHoldValue,
      id: awbInfo.id,
    };

    try {
      await axios.post(url, body);
      await updateAcasInfo(awbInfo.id);
      setLoading(false);
      Swal.fire({
        title: "Aceptado",
        text: "Los datos de acas se han guardado correctamente",
        icon: "success",
      });
    } catch (error) {
      setLoading(false);
      console.error(error.response.data.body);
      Swal.fire("Error", error.response.data.body, "error");
    }
  };

  return (
    <>
      <div className="acas-info-container">
        <div className="acas-aceptation-container">
          <h4>Aceptación</h4>
          <div className="divider-vertical"></div>
          <p>Guía: {awbInfo.awb}</p>
        </div>

        <div className="acas-information">
          <div className="acas-row">
            <div className="info-box">
              <p className="text-bold">Master:</p>
              <p>{awbInfo.awb}</p>
            </div>

            <div className="info-box">
              <p className="text-bold">Origen:</p>
              <p>{awbInfo.orig}</p>
            </div>

            <div className="info-box">
              <p className="text-bold">Destino:</p>
              <p>{awbInfo.dest}</p>
            </div>

            <div className="info-box">
              <p className="text-bold">Piezas:</p>
              <p>{awbInfo.pieces}</p>
            </div>
          </div>

          <div className="acas-row">
            <div className="info-box">
              <p className="text-bold">Peso:</p>
              <p>{awbInfo.weight}</p>
            </div>

            <div className="info-box">
              <p className="text-bold">Volúmen:</p>
              <p>{awbInfo.volume}</p>
            </div>

            <div className="info-box">
              <p className="text-bold">Tipo de mercancía:</p>
              <p>{awbInfo.merch}</p>
            </div>
          </div>

          {!existAcas.existAcas ? (
            <div
              className="acas-row mt-4"
              onSubmit={handleSubmit(handleAcceptAca)}
            >
              <form className="accept-form">
                <div className="inputs-acas-form">
                  <p>¿Aceptado?</p>
                  <div className="acas-input-content">
                    <label htmlFor="accept">Si</label>
                    <br></br>
                    <input
                      type="radio"
                      id="accept"
                      name="accept"
                      value="true"
                      {...register("acasvalue")}
                    />
                  </div>
                  <div className="acas-input-content">
                    <label htmlFor="noAcept">No</label>
                    <br></br>
                    <input
                      type="radio"
                      id="noAcept"
                      name="noAcept"
                      value="false"
                      {...register("acasvalue")}
                    />
                  </div>
                </div>

                {acasValue === "false" && (
                  <div className="inputs-acas-form">
                    <p>Colocación de identificador "ON HOLD"</p>
                    <div className="acas-input-content">
                      <label htmlFor="holdYes">Si</label>
                      <br></br>
                      <input
                        type="radio"
                        id="holdYes"
                        name="holdYes"
                        value="true"
                        {...register("onHoldValue")}
                      />
                    </div>
                    <div className="acas-input-content">
                      <label htmlFor="holdNot">No</label>
                      <br></br>
                      <input
                        type="radio"
                        id="holdNot"
                        name="holdNot"
                        value="false"
                        {...register("onHoldValue")}
                      />
                    </div>
                  </div>
                )}

                <div className="btn-content-acas">
                  <button className="btnn">Guardar</button>
                </div>
              </form>
            </div>
          ) : (
            <div className="contet-texts-acas">
              <div className="content-text-acas">
                <p className="info">Aceptado:</p>{" "}
                <span>{existAcas.accepted == "1" ? "Si" : "No"}</span>
              </div>
              <div className="content-text-acas">
                <p className="info">Colocación de identificador "ON HOLD":</p>{" "}
                <span>{existAcas.onhold == "1" ? "Si" : "No"}</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        show={loading}
        onHide={() => setLoading(false)}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="custom-modal"
        backdropClassName="custom-backdrop"
      >
        <div className="spinner-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
        </div>
      </Modal>
    </>
  );
}

export default AcasInfo;
